interface ErrorPagePropsInput {
  statusCode?: number;
  jobLinks?: any;
  socialLinks?: any;
  themeType?: string;
  basePathRewrite?: any;
  isCategoriesPage?: boolean;
  jobTitle?: string;
  isSearchPage?: boolean;
}
export default function errorPageProps(props: ErrorPagePropsInput) {
  const {
    statusCode,
    jobLinks,
    socialLinks,
    themeType,
    basePathRewrite,
    jobTitle,
    isSearchPage,
    isCategoriesPage,
  } = props;
  return {
    statusCode,
    jobLinks,
    socialLinks,
    themeType,
    basePathRewrite,
    jobTitle,
    isSearchPage,
    isCategoriesPage,
  };
}
